import React, { useCallback, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { ButtonDeprecated } from '@pkg/components';
import { useAppDispatch } from '@pkg/hooks';

import { setNftMintPanelStep, setNftPanelOpen } from '@app/store/actions/nft';

import { Typography } from '../../../DesignSystem';
import '../NftSidePanel.scss';

interface RenameNftFeedbackProps {
    type: 'cancel' | 'success';
}
export const RenameNftFeedback = ({ type }: RenameNftFeedbackProps) => {
    const { t } = useTranslation(['nft', 'words']);
    const dispatch = useAppDispatch();

    const closeSidePanel = useCallback(() => {
        dispatch(setNftPanelOpen(false));
        dispatch(setNftMintPanelStep(null));
    }, [dispatch]);

    const handleKeyDown = useCallback(
        (e) => {
            // Submit on Enter pressed
            if (e.key === 'Enter') {
                e.preventDefault();
                closeSidePanel();
            }
        },
        [closeSidePanel],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    const title = type === 'success' ? t('your_yat_has_been_renamed') : t('your_yat_is_all_done');
    const text = type === 'success' ? t('nft_rename_feedback_success') : t('nft_rename_feedback_cancel');

    return (
        <div className="yat-nft-sidebar__step yat-nft-sidebar__rename-feedback">
            <div className="yat-nft-sidebar__flex-item">
                <Typography type="headline" size={60} classes={['yat-nft-sidebar__title']}>
                    <span className="yat-nft-sidebar__title-text">{title}</span>
                    <span
                        className="yat-nft-sidebar__title-emoji"
                        role="img"
                        aria-label={t('emoji', { emoji: 'Tada' })}
                    >
                        {' '}
                        🎉
                    </span>
                </Typography>

                <Typography type="paragraph" size={16} classes={['yat-nft-sidebar__text']}>
                    <span dangerouslySetInnerHTML={{ __html: text }}></span>
                </Typography>

                <ButtonDeprecated
                    classes={['nft-sidebar-cta-desktop']}
                    color="primary"
                    onClick={closeSidePanel}
                    size="hero"
                >
                    {t('words:awesome')}
                </ButtonDeprecated>
                <ButtonDeprecated
                    classes={['nft-sidebar-cta-mobile']}
                    color="primary"
                    fluid
                    onClick={closeSidePanel}
                    size="large"
                >
                    {t('words:awesome')}
                </ButtonDeprecated>
            </div>
        </div>
    );
};
